import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LyricItem, SongItem } from '@/types/player-api'
import { SimiPlaylist, SimiSong } from '@/types/player-api'

interface PlayerState {
    playList: SongItem[]
    currentSongIndex: number
    currentSong: SongItem // 当前播放歌曲
    sequence: number // 0 循环 1 随机 2 单曲
    lyricList: LyricItem[] // 歌词
    currentLyricIndex: number // 歌词所在位置
    simiPlaylist: SimiPlaylist[]
    simiSongs: SimiSong[]
}

const initialState: PlayerState = {
    playList: [],
    currentSongIndex: 0,
    currentSong: {} as SongItem, // 当前播放歌曲
    sequence: 0, // 0 循环 1 随机 2 单曲
    lyricList: [], // 歌词
    currentLyricIndex: 0, // 歌词所在位置
    simiPlaylist: [],
    simiSongs: [],
}

const playerSlice = createSlice({
    name: 'player',
    initialState,
    reducers: {
        changePlayList(state, action: PayloadAction<SongItem[]>) {
            state.playList = action.payload
        },
        changeCurrentSongIndex(state, action: PayloadAction<number>) {
            state.currentSongIndex = action.payload
        },
        changeCurrentSong(state, action: PayloadAction<SongItem>) {
            state.currentSong = action.payload
        },
        changeSequence(state, action: PayloadAction<number>) {
            state.sequence = action.payload
        },
        changeLyricList(state, action: PayloadAction<LyricItem[]>) {
            state.lyricList = action.payload
        },
        changeCurrentLyricIndex(state, action: PayloadAction<number>) {
            state.currentLyricIndex = action.payload
        },
        changeSimiPlaylist(state, action: PayloadAction<SimiPlaylist[]>) {
            state.simiPlaylist = action.payload
        },
        changeSimiSongs(state, action: PayloadAction<SimiSong[]>) {
            state.simiSongs = action.payload
        },
    },
})

export const {
    changePlayList,
    changeCurrentSongIndex,
    changeCurrentSong,
    changeSequence,
    changeLyricList,
    changeCurrentLyricIndex,
    changeSimiPlaylist,
    changeSimiSongs,
} = playerSlice.actions
export default playerSlice.reducer
